import React, { Component, useEffect, useState } from 'react';
import { Input, Modal, Button, Tabs, Row, Col, Tooltip, Popconfirm, AutoComplete, Checkbox, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Home_Address from '../Inc/Address.js/Home_Address';
import Business_Address from '../Inc/Address.js/Business_Address';
import Vacation_Address from '../Inc/Address.js/Vacation_Address';
import NESA_Address from '../Inc/Address.js/NESA_Address';
import './profile.css';
import Skeleton from 'react-loading-skeleton';
const TabPane = Tabs.TabPane;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};


const AddressInfoForm = (props) => {
    const [state, setState] = useState({
        forceRender: true,
        isInEditMode: false,
        defaultActiveKey: '1',
        ZIPcode: ''
    });

    useEffect(() => {
        props.actions.getAddressTypes()
    }, []);

    const renderAddress = (profileinfo) => {
        const { getFieldDecorator, getFieldValue } = props.form;
        const address = profileinfo.addresses
        const types = props.types

        let Home = ''
        let Business = ''
        let Vacation = ''
        let NESA = ''

        if (props.types) {
            address.map((k, index) => {
                if (k.typeId === "65") {
                    Home = k
                }
                if (k.typeId === "64") {
                    Business = k
                }
                if (k.typeId === "70") {
                    Vacation = k
                }
                if (k.typeId === "68") {
                    NESA = k
                }
            });

            if (props.types) {

                const primaryAddress = address.find((k) => k.isPrimary === 'True' );
                const DefaultAddress = (primaryAddress || {}).typeId || '65';

                return (
                    <div>
                        <Tabs defaultActiveKey={DefaultAddress}>
                            <TabPane tab={<span> HOME {Home ? (Home.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="65">
                                <Home_Address by="alumni" />
                            </TabPane>
                            <TabPane tab={<span> BUSINESS {Business ? (Business.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="64">
                                <Business_Address by="alumni" />
                            </TabPane>
                            <TabPane tab={<span> VACATION {Vacation ? (Vacation.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="70">
                                <Vacation_Address by="alumni" />
                            </TabPane>
                            <TabPane tab={<span> NESA {NESA ? (NESA.isPrimary) === 'True' ? <Tooltip title="Primary Address"><Icon className='margin-left-5' type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></Tooltip> : "" : ""} </span>} key="68">
                                <NESA_Address by="alumni" />
                            </TabPane>
                        </Tabs>
                    </div>
                );
            }
        }
    };

    const renderEditView = () => {
        if (props.profileinfo) {
            return renderAddress(props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
        }
    };

    return (
        <div className='address-profile-info'>
            <div className='container'>
                <div className='widget-content'>
                    <Row type="flex" justify="space-between">
                        <div className='widget-header-text'>
                            My Address Information
                          </div>
                        <div className='widget-header-tool'>
                            {/* <label className='pointer' onClick={showModal} > Add New </label> */}
                        </div>
                    </Row>
                    <Row className='widget-content-section alumni-ui' type="flex" justify="center" align="middle">
                        {renderEditView()}
                    </Row>
                </div>
            </div>
        </div>
    );
};


function mapStateToProps(state) {
    return {
        loading: state.profilereducer.loading, 
        profileinfo: state.profilereducer.profileinfo,
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        types: state.addresstypesreducer.types,
        homeAddressLoading: state.homeaddressreducer.loading,
        HomeAddress: state.homeaddressreducer.address
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
const AddressInfo = Form.create()(AddressInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AddressInfo);



// WEBPACK FOOTER //
// ./src/components/MyProfile/AddressInfo.js